export default __webpack_public_path__ + "static/media/17.594df9a6.png";